module.exports = require("./../internal/prefix") + "key";
